import { CommonModule } from '@angular/common';
import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

export enum ButtonColor {
  BLUE = 'blue',
  RED = 'red',
}

@Component({
  selector: 'app-text-button',
  imports: [CommonModule],
  templateUrl: './text-button.component.html',
  styleUrl: './text-button.component.css',
})
export class TextButtonComponent {
  @Input() color: ButtonColor;
  @Input() disabled = false;
  @Input() isLoading = false;
  @Input() showOutline = false;
  @ContentChild(TemplateRef) content!: TemplateRef<{
    disabled: boolean;
    isLoading: boolean;
  }>;
}
